import { IClientConfig } from "src/client-config/config";
import { IMainStore } from "src/stores/main";

export const getPlaceBetLabel = (config: IClientConfig, mainState: IMainStore) => {
  if (config.placeBetLabel) return config.placeBetLabel;

  if (mainState.editingBet) return 'Save and place bet';

  if (mainState.isFreeBetEnabled) return 'Place free bet';

  return 'Place bet';
};